import { Space, Table, Button, Switch, message } from "antd";
import { EditOutlined, DeleteOutlined, CheckCircleFilled, CloseCircleFilled } from "@ant-design/icons";
import { useState } from "react";
import axios from "axios"; // Assuming you are using Axios for API requests
import VerificadorOverview from "./VerificadorOverview";

export default function VerificadoresIndex(props) {
  const { inspectors, setInspectors, loading, isModalVisible, setIsModalVisible, isEdit, setIsEdit, record, setRecord } = props;

  const handleActivoChange = (email, newActivoStatus) => {
    axios
      .patch(`${process.env.REACT_APP_API_URL}/verificadores/${email}`, { Activo: newActivoStatus })
      .then((response) => {
        axios.get(`${process.env.REACT_APP_API_URL}/verificadores/getVerificadores`).then((response) => {
          setInspectors(response.data);
        });
        message.success("Verificador " + (newActivoStatus === 1 ? "activado" : "desactivado") + " correctamente");
      })
      .catch((error) => {
        message.error("Error desactivando verificador");
        console.error(error);
      });
  };

  const columns = [
    {
      title: "Nombre",
      dataIndex: "Nombre",
      key: "Nombre",
      render: (text, record) => record.Nombre + " " + record.Apellido || <span className="subtle-text">N/D</span>,
    },
    {
      title: "Rol",
      dataIndex: "Rol",
      key: "Rol",
      render: (text) => text || <span className="subtle-text">N/D</span>,
    },
    {
      title: "Activo",
      dataIndex: "Activo",
      key: "Activo",
      render: (text, record) => (
        <Switch
          checked={text === 1}
          onChange={(checked) => handleActivoChange(record.Email, checked ? 1 : 0)}
          checkedChildren={<CheckCircleFilled style={{ color: "#52c41a" }} />}
          unCheckedChildren={<CloseCircleFilled style={{ color: "red" }} />}
        />
      ),
    },
    
  ];

  return (
    <div>
      <Table
        columns={columns}
        dataSource={inspectors}
        loading={loading}
        rowKey="Email"
        expandable={{
          expandedRowRender: (record) => <VerificadorOverview inspector={record} />,
        }}
        pagination={{
          pageSize: 25,
          showSizeChanger: true,
          showLessItems: true,
        }}
        scroll={{
          x: "max-content",
          y: "calc(100vh - 300px)",
        }}
      />
    </div>
  );
}
